import { pageSelectorGenerator } from '@test/pageSelectors';

export const ExternalCheckoutReviewSelectors = pageSelectorGenerator('ExternalCheckoutReview', ['ContainerElement', 'LetsGoToButton', 'CancelButton']);
